// ============================================================================
// CANCUN100 — contacto.js  (Bloque 26: los teléfonos oficiales viven SOLO aquí)
// ----------------------------------------------------------------------------
// | Uso                                                   | Número         |
// | WhatsApp oficial (Sala de Ventas y canal Admin)       | 998 763 7653   |
// | Oficina, llamadas fijas                               | 998 361 1590   |
// | "Aventuras con Pao" — WhatsApp y llamadas, Top Tours  | 998 601 6777   |
// Nunca el teléfono personal del agente (regla vigente).
// ============================================================================
export const TEL_OFICINA = '998 361 1590';
export const WA_SALA = '998 763 7653';
export const WA_TOP_TOURS = '998 601 6777';
export const NOMBRE_WA_TOP_TOURS = 'Aventuras con Pao';
export const EMAIL = 'info@cancun100.com';
export const DIRECCION = 'Calle Tejón 14, Cancún Q.Roo. México';
export const DIRECCION_ASCII = 'Calle Tejon 14, Cancun Q.Roo. Mexico'; // para PDFs con fuentes sin acentos
// Contabilidad v3 (Bloque 46): número (o grupo) de WhatsApp de RESERVACIONES al que la app manda las solicitudes por ítem.
// PENDIENTE: Marco debe dar el número (10 dígitos). Vacío = WhatsApp abre el selector de chat con el texto listo.
export const RESERVACIONES_WA = '';

// Bloque 36 (B): la ÚNICA lista de "Línea de contacto" (reservas.linea_contacto, texto libre en mayúsculas), en este orden.
// 'OTRO' habilita linea_contacto_otro. RP_VENTA_POR_FUERA va aparte: solo se ofrece a agentes con puede_rp_por_fuera.
export const LINEAS_CONTACTO = ['CANCUN100', 'TOP TOURS', 'CANCUNTRIPS', 'CANCUNATVS', 'OTRO'];
export const RP_VENTA_POR_FUERA = 'RP VENTA POR FUERA';
export const ETIQUETA_RP = '🎯 RP VENTA POR FUERA (80%)';

// canal: 'sala' | 'top_tours' | 'admin' (o true/false de es_top_tours)
export const canalDe = (x) => (x === true || x === 'top_tours' || x === 'tt' ? 'top_tours' : x === 'admin' ? 'admin' : 'sala');
export const contactoPorCanal = (canal) => {
  const c = canalDe(canal);
  return {
    canal: c,
    telefono: TEL_OFICINA,
    whatsapp: c === 'top_tours' ? WA_TOP_TOURS : WA_SALA,
    whatsappE164: '+52 ' + (c === 'top_tours' ? WA_TOP_TOURS : WA_SALA),
    etiquetaWhatsapp: c === 'top_tours' ? `WhatsApp (${NOMBRE_WA_TOP_TOURS})` : 'WhatsApp',
    email: EMAIL,
  };
};
// Línea de pie para PDFs/listas: "Tel: … | WA: … | info@…"
export const lineaContacto = (canal) => { const k = contactoPorCanal(canal); return `${DIRECCION_ASCII}  |  Tel: ${k.telefono}  |  WA: ${k.whatsapp}  |  ${k.email}`; };
